import React from 'react';
import { FaGift } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#150F0F] flex flex-col justify-center items-center text-white pt-6 sm:pt-10 text-xs sm:text-sm mt-[4rem] sm:mt-[7rem]">
      <div
        className="footer-container flex flex-col items-center justify-center w-full max-w-[95rem] mx-auto px-4 sm:px-6"
      >
        {/* Top Banner Image */}
        <img
          src="/footer/nha-cung-cap-tro-choi-u888.png"
          alt="Nhà cung cấp trò chơi U888"
          className="w-full object-cover"
        />

        {/* Main Grid Content */}
        <div className="mx-auto w-full grid grid-cols-1 md:grid-cols-[1.5fr_2fr_1.5fr] gap-6 sm:gap-8 mt-6 sm:mt-10">
          {/* Left Section */}
          <div className="flex flex-col items-center">
            <img src="/logo-u888.png" alt="U888" className="h-[5rem] sm:h-[7rem]" />
            <div className="flex flex-col items-center justify-between">
              <div className='mt-[10px]'>
                <p className="text-lg sm:text-2xl text-gray-300 leading-relaxed mb-4">
                  {t('footer.content')}
                </p>
              </div>
              <div className='w-[90%] sm:w-[80%]'>
                <img src="footer/chung-nhan-do-tuoi-tham-gia-u888.png" alt="PAGCOR" className="h-[7rem] sm:h-[9rem] w-full" />
              </div>
            </div>
          </div>

          {/* Center Section - Games and Guides */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 w-full h-full">
            <div className="text-lg sm:text-2xl">
              <h4 className="text-white font-bold mb-2 sm:mb-3 text-lg">{t('footer.title-1')}</h4>
              <ul className="flex flex-col gap-2 sm:gap-[15px] mt-3 sm:mt-[20px] space-y-1 sm:space-y-2 text-gray-300">
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/casino" className="flex items-center gap-2 w-full">
                    <FaGift className="text-white" /> {t('footer.casino')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/sports" className="flex items-center gap-2 w-full">
                    <FaGift className="text-white" /> {t('footer.sports')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/card-games" className="flex items-center gap-2 w-full">
                    <FaGift className="text-white" /> {t('footer.card_games')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/cockfighting" className="flex items-center gap-2 w-full">
                    <FaGift className="text-white" /> {t('footer.cockfighting')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/lottery" className="flex items-center gap-2 w-full">
                    <FaGift className="text-white" /> {t('footer.lottery')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/sitemap" className="flex items-center gap-2 w-full">
                    <FaGift className="text-white" /> {t('footer.sitemap')}
                  </a>
                </li>
              </ul>
            </div>

            {/* <div className="text-lg sm:text-2xl">
              <h4 className="text-white font-bold mb-2 sm:mb-3 text-lg">{t('footer.title-2')}</h4>
              <ul className="flex flex-col gap-2 sm:gap-[15px] mt-3 sm:mt-[20px] space-y-1 sm:space-y-2 text-gray-300">
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/register" className="flex items-center gap-2 w-full">
                    <GiHamburgerMenu className="text-white" /> {t('footer.register')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/login" className="flex items-center gap-2 w-full">
                    <GiHamburgerMenu className="text-white" /> {t('footer.login')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/deposit" className="flex items-center gap-2 w-full">
                    <GiHamburgerMenu className="text-white" /> {t('footer.deposit')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/withdraw" className="flex items-center gap-2 w-full">
                    <GiHamburgerMenu className="text-white" /> {t('footer.withdraw')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/download" className="flex items-center gap-2 w-full">
                    <GiHamburgerMenu className="text-white" /> {t('footer.download_app')}
                  </a>
                </li>
                <li className="flex items-center gap-2 hover:text-white transition-colors">
                  <a href="/about" className="flex items-center gap-2 w-full">
                    <GiHamburgerMenu className="text-white" /> {t('footer.author_ceo')}
                  </a>
                </li>
              </ul>
            </div> */}
          </div>

          {/* Right Section - Payment Methods and Licenses */}
          <div className='w-full sm:w-[85%] flex flex-col items-center'>
            <img src="footer\thong-tin-thanh-toan.png" alt="PAGCOR" className="h-[15rem] sm:h-[20rem] w-full sm:w-[90%]" />
            <img src="footer\chung-nhan-tin-nhiem-mang.png" alt="PAGCOR" className="mt-4 sm:mt-[20px] h-[9rem] sm:h-[12rem] w-full sm:w-[90%]" />
          </div>
        </div>
      </div>
      {/* Bottom Text */}
      <div className="w-full bg-black py-4 sm:py-6 text-center mt-[4rem] sm:mt-[10rem]">
        <div className="text-base sm:text-lg font-semibold text-white">
          {/* {t("footer.partner_text")} */}
        </div>
        <div className="text-sm sm:text-md text-gray-400 mt-1 sm:mt-2">
          {t("footer.copyright")}{" "}
          <span className="font-semibold text-white">{t("footer.reserved")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 